import React, { Suspense, useState } from "react";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import { CFooter, CHeader } from "@coreui/react";
import "./style.css";
import { useMediaQuery } from "react-responsive";
import Sidebar from "./Sidebar/Sidebar";
import SidebarHeader from "./Sidebar/SidebarHeader";
import { useLocation , Outlet } from "react-router-dom";
import LoadingIndicator from "../../utils/LoadingIndicator";
import TopbarIPad from "./Header/TopBar/TopBar";
import MyAccountFooter from "./Footer/MyAccountFooter";
import { checkIfAccountSection } from "../../utils/checkAccountSection";
import { HOME_URL } from "../../utils/constants";
import TeamActivityDrawer from "../ActivityTicker/TeamActivityDrawer";
import RouteTransition from "./RouteTransition";

const Layout = () => {
	let location = useLocation();
	const isHomePage = location.pathname === HOME_URL

	// Shared open/close state so the Header's "Activity" link and the
	// ticker's "See all activities" button both open the same drawer.
	const [activityDrawerOpen, setActivityDrawerOpen] = useState(false);
	const openActivityDrawer = () => setActivityDrawerOpen(true);
	const closeActivityDrawer = () => setActivityDrawerOpen(false);

	// desktop screen to check if it's in the myAccount section
	const isDestopScreen =
		useMediaQuery({
			query: "(min-device-width: 1280px)",
		}) && (checkIfAccountSection(location))

	// ipad screen to check if it's in the myAccount section	
	const isIpadScreen =
		useMediaQuery({ maxDeviceWidth: "1280px", minDeviceWidth: "700px" }) &&
		(checkIfAccountSection(location))
	return (
		<>
			{isDestopScreen ? (
				<div className='profile-app'>
					<Sidebar />
					<main className='app-window'>
						<SidebarHeader />
						<Suspense fallback={<LoadingIndicator context="brand" />}>
							<RouteTransition>
								<Outlet></Outlet>
							</RouteTransition>
						</Suspense>

						{/* the below condition is because we've different type of footers for home page and account section */}
						{checkIfAccountSection(location) ? (
							<MyAccountFooter />
						) : (
							<Footer />
						)}
					</main>
				</div>
			) : (
				<div className='app'>
					<CHeader className='marginfornav' fixed='true'>
						<Header onOpenActivity={openActivityDrawer} />
					</CHeader>
					<div className='app-body'>
						<main className={isHomePage ? "main-home" : "main"}>
							{isIpadScreen && <TopbarIPad />}
							<Suspense fallback={<LoadingIndicator context="brand" />}>
							<RouteTransition>
								<Outlet></Outlet>
							</RouteTransition>
							</Suspense>
						</main>
					</div>
					<CFooter className='footer'>
						<Footer />
					</CFooter>
				</div>
			)}
			<TeamActivityDrawer open={activityDrawerOpen} onClose={closeActivityDrawer} />
		</>
	);
};

export default Layout;